import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { ReactSVG } from 'react-svg';

const baseStyles = () => css`
  display: block;
  width: 100%;
  max-width: 500px;
  height: auto;
  margin: auto;
`;

const naturalStyles = ({ naturalSize }) =>
  naturalSize &&
  css`
    width: auto;
    max-width: none;
  `;

const StyledImage = styled('img')(baseStyles, naturalStyles);

const Image = ({ isSvg, ...props }) => {
  if (isSvg) {
    return <ReactSVG src={props.src} />;
  }

  return <StyledImage {...props} />;
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  naturalSize: PropTypes.bool,
  isSvg: PropTypes.bool,
};

Image.defaultProps = {
  src: 'https://cdn.rbi.digital/hockey/sticks.svg',
  alt: '',
  isSvg: false,
};

export default Image;
